import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, Transition as _Transition, withCtx as _withCtx, resolveComponent as _resolveComponent } from "vue"

const _hoisted_1 = { class: "overflow-x-hidden" }
const _hoisted_2 = {
  key: 0,
  class: "w-screen h-screen flex flex-col items-center justify-center"
}
const _hoisted_3 = {
  key: 0,
  class: "px-20 py-10 text-center text-sm font-bold text-red-500"
}
const _hoisted_4 = { class: "mt-8" }
const _hoisted_5 = {
  key: 1,
  class: "container mx-auto p-4"
}
const _hoisted_6 = { class: "flex flex-col-reverse md:mb-4 md:flex-row gap-4 justify-between md:items-start" }
const _hoisted_7 = { class: "md:w-1/3 xl:w-1/4 px-8 md:px-0" }
const _hoisted_8 = ["src"]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "viewing-list-header__settings" }, null, -1)
const _hoisted_10 = { class: "md:mb-8 p-4 bg-slate-200 rounded-xl space-y-4 intro-box" }
const _hoisted_11 = {
  key: 0,
  class: "text-lg font-bold intro-title"
}
const _hoisted_12 = { class: "intro-text" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

import { onMounted, toRefs } from 'vue'
    import { useCustomerData } from '@/composables/customerData'
    import LoaderClouds from '@/components/loaders/LoaderClouds.vue'
    import FancyButton from '@/components/ui/FancyButton.vue'
    import { Branding } from '@/interface'
    import { formatRelatieNaam } from '@/helpers/relatie'
    import color from 'color'

    
export default /*#__PURE__*/_defineComponent({
  props: {
    linkId: null
  },
  setup(__props: any) {

const props = __props as { linkId: string }

    const baseUrl = `${process.env.VUE_APP_API_BASEURL}/attachments/`
    
    const { linkId } = toRefs(props)
    const { error, loading, branding, viewings, loadInitialData } = useCustomerData()
    const updateRootVariables = (branding: Branding) => {
        const root = document.documentElement
        const fontFamily = branding.fontFamily
        const styles = {
            'buttonColorUpcoming': color(branding.buttonColorUpcoming),
            'buttonColorCompleted': color(branding.buttonColorCompleted),
            'titleColorWelcomeUser': color(branding.titleColorWelcomeUser),
            'textColorWelcomeUser': color(branding.textColorWelcomeUser),
            'subHeaderColorActive': color(branding.subHeaderColorActive),
            'subHeaderColorInactive': color(branding.subHeaderColorInactive),
            'titleColorWoning': color(branding.titleColorWoning),
            'textColorInfoWoning': color(branding.textColorInfoWoning),
            'textColorWaardesWoning': color(branding.textColorWaardesWoning),
            'svgColorWaardesWoning': color(branding.svgColorWaardesWoning),
            'buttonColorRoute': color(branding.buttonColorRoute),
            'buttonBackgroundColorRoute': color(branding.buttonBackgroundColorRoute),
            'buttonColorRouteData': color(branding.buttonColorRouteData),
            'titleColorDate': color(branding.titleColorDate),
            'textColorDate': color(branding.textColorDate),
            'buttonBackgroundColorCompleted': color(branding.buttonBackgroundColorCompleted),
            'backgroundColorHeader': color(branding.backgroundColorHeader),
            'backgroundColorPage': color(branding.backgroundColorPage),
            'buttonColorUpcomingDarker': color(branding.buttonColorUpcoming).mix(color('black'), 0.1),
            'buttonColorCompletedDarker': color(branding.buttonColorCompleted).mix(color('black'), 0.1),
        }

        root.style.setProperty('--fontFamily', fontFamily)

        for (const [key, value] of Object.entries(styles)) {
            root.style.setProperty(`--${key}`, value.array().join(' '))
        }

        window.document.title = `${branding.name} Relatieportaal`

        if (branding.emmaEnabled) {
            var s = document.createElement('script')
            s.type = 'text/javascript'
            s.async = true
            s.src = `${process.env.VUE_APP_APP_BASEURL}/embed/widget.js?company=${branding.id}&flow=valuation`
            document.body.appendChild(s)
        }
    }

    onMounted(async() => {
        await loadInitialData(linkId.value)

        if (branding.value) {
            updateRootVariables(branding.value)
        }
    })

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createBlock(_component_router_view, null, {
    default: _withCtx(({ Component }) => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_Transition, {
          name: "transition-slide",
          mode: "out-in"
        }, {
          default: _withCtx(() => [
            (_unref(loading))
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  _createVNode(LoaderClouds),
                  (_unref(error))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                        _createElementVNode("div", null, _toDisplayString(_unref(error)), 1),
                        _createElementVNode("div", _hoisted_4, [
                          _createVNode(FancyButton, {
                            color: "red",
                            title: _ctx.$t('action.retry'),
                            onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(loadInitialData)(_unref(linkId))))
                          }, null, 8, ["title"])
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : (_unref(branding))
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    _createElementVNode("div", _hoisted_6, [
                      _createElementVNode("div", _hoisted_7, [
                        _createElementVNode("img", {
                          class: "object-contain max-h-24 mx-auto md:mx-0 mb-4 md:mb-0",
                          src: `${baseUrl}${_unref(branding).logoPath}`
                        }, null, 8, _hoisted_8)
                      ]),
                      _hoisted_9
                    ]),
                    _createElementVNode("div", _hoisted_10, [
                      (_unref(viewings).length)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(_ctx.$t('intro.welcome', { relatieNaam: _unref(formatRelatieNaam)(_unref(viewings)[0].relatie) })) + ", ", 1))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_12, [
                        (_unref(branding).id === '6da1b12b-860d-401f-8bd0-26cf834ef766')
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _createTextVNode(_toDisplayString(_ctx.$t('intro.line1-vlieg' )), 1),
                              _hoisted_13,
                              _createTextVNode(" " + _toDisplayString(_ctx.$t('intro.line2-vlieg' )), 1),
                              _hoisted_14,
                              _createTextVNode(" " + _toDisplayString(_ctx.$t('intro.line3-vlieg' )), 1),
                              _hoisted_15,
                              _createTextVNode(" " + _toDisplayString(_ctx.$t('intro.line4-vlieg' )), 1),
                              _hoisted_16
                            ], 64))
                          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                              _createTextVNode(_toDisplayString(_ctx.$t('intro.line1', { brandingName: _unref(branding).name } )), 1),
                              _hoisted_17,
                              _createTextVNode(" " + _toDisplayString(_ctx.$t('intro.line2' )), 1),
                              _hoisted_18,
                              _createTextVNode(" " + _toDisplayString(_ctx.$t('intro.line3' )), 1),
                              _hoisted_19
                            ], 64))
                      ])
                    ]),
                    _createElementVNode("div", null, [
                      (_openBlock(), _createBlock(_resolveDynamicComponent(Component)))
                    ])
                  ]))
                : _createCommentVNode("", true)
          ]),
          _: 2
        }, 1024)
      ])
    ]),
    _: 1
  }))
}
}

})